import { useEffect, useState } from "react";
import { MultiSelect } from "primereact/multiselect";

import { PropsWithClassName } from "../../common/types/PropsWithClassName";
import { Team } from "./Team";
import { fetchTeamsByDepartment } from "./teamsApi";
import { NoResultsFoundText } from "../../common/components/noResultsFound/NoResultsFound";

interface TeamsMultiSelectProps extends PropsWithClassName {
  departmentId: string;
  value?: string[];
  showClear?: boolean;
  onChange: (teamsIds?: string[]) => void;
}

export default function TeamsMultiSelect({ className, departmentId, value, showClear, onChange }: TeamsMultiSelectProps) {
  const [teams, setTeams] = useState<Team[]>([]);
  const selectedTeams = teams.filter((team) => value?.includes(team.id));

  useEffect(() => {
    const doFetchTeamsByDepartment = async () => {
      if (departmentId) {
        const teams = await fetchTeamsByDepartment(departmentId);
        setTeams(teams);
      }
    };
    doFetchTeamsByDepartment();
  }, [departmentId]);

  return (
    <MultiSelect
      className={`${className}`}
      placeholder="Selecteaza grupa"
      optionLabel="name"
      options={teams}
      value={selectedTeams}
      showClear={showClear}
      emptyMessage={NoResultsFoundText}
      onChange={(e) => onChange(e.value.map((team: Team) => team.id))}
    />
  );
}
